// extracted by mini-css-extract-plugin
export var avatarContainer = "_47-0";
export var gray = "_47-f";
export var green = "_47-c";
export var icon = "_47-9";
export var image = "_47-1";
export var lg = "_47-6";
export var md = "_47-5";
export var presenceDot = "_47-b";
export var red = "_47-d";
export var sm = "_47-4";
export var status = "_47-a";
export var xl = "_47-7";
export var xs = "_47-3";
export var xxl = "_47-8";
export var xxs = "_47-2";
export var yellow = "_47-e";